import React, { useMemo } from 'react';
import { newMathFormatForcePadEndZeroWrapper as newMathFormat } from '@gp/utils/common';

import type { IBaseProps } from '@home/types/common';

export interface INetProfitCardData {
  min?: number;
  max?: number;
  studio?: number;
  bpm?: number;
  fbi?: number;
}

interface INetProfitCardProps extends IBaseProps {
  data?: INetProfitCardData;
}

const NetProfitCard: React.FC<INetProfitCardProps> = (props) => {
  const { data } = props;
  const { min, max, studio, bpm, fbi } = data || {};

  const y3Revenue = useMemo<string>(() => {
    const res = [min, max]
      .filter((num) => !Number.isNaN(Number.parseFloat(num as any)))
      .map((num) => newMathFormat(num, true))
      .join(' - ');
    return res || '-';
  }, [min, max]);

  return (
    <div className="dbg-finance-card-context">
      <div className="dbg-finance-card-num">{y3Revenue}</div>
      <div className="dbg-finance-card-text">
        <div className="dbg-finance-card-text-item">
          <div className="dbg-finance-card-label">Studio</div>
          <div className="dbg-finance-card-desc">{newMathFormat(studio, true)}</div>
        </div>
        <div className="dbg-finance-card-text-item">
          <div className="dbg-finance-card-label">Publishing Team</div>
          <div className="dbg-finance-card-desc">{newMathFormat(bpm, true)}</div>
        </div>
        <div className="dbg-finance-card-text-item">
          <div className="dbg-finance-card-label">FBI</div>
          <div className="dbg-finance-card-desc">{newMathFormat(fbi, true)}</div>
        </div>
      </div>
    </div>
  );
};

export default NetProfitCard;
